export const EMPTY_MERCH_SHIPPING_ADDRESS = {
  nome: '',
  cognome: '',
  line1: '',
  city: '',
  zip: '',
  country: 'IT',
};

export function normalizeMerchShippingAddress(address) {
  if (!address || typeof address !== 'object') return null;

  const normalized = {
    nome: String(address.nome || '').trim(),
    cognome: String(address.cognome || '').trim(),
    line1: String(address.line1 || '').trim(),
    city: String(address.city || '').trim(),
    zip: String(address.zip || '').trim(),
    country: String(address.country || 'IT').trim() || 'IT',
  };

  if (
    !normalized.nome ||
    !normalized.cognome ||
    !normalized.line1 ||
    !normalized.city ||
    !normalized.zip
  ) {
    return null;
  }

  return normalized;
}

export function isMerchShippingAddressComplete(address) {
  return normalizeMerchShippingAddress(address) != null;
}

export function formatMerchShippingAddress(address) {
  const normalized = normalizeMerchShippingAddress(address);
  if (!normalized) {
    if (!address) return null;
    const fallbackName = [address.nome, address.cognome]
      .filter(Boolean)
      .join(' ')
      .trim();
    const parts = [
      fallbackName,
      address.line1,
      [address.zip, address.city].filter(Boolean).join(' '),
      address.country && address.country !== 'IT' ? address.country : null,
    ].filter(Boolean);
    return parts.length > 0 ? parts.join(', ') : null;
  }

  const parts = [
    `${normalized.nome} ${normalized.cognome}`.trim(),
    normalized.line1,
    [normalized.zip, normalized.city].filter(Boolean).join(' '),
    normalized.country !== 'IT' ? normalized.country : null,
  ].filter(Boolean);

  return parts.join(', ');
}

export function getMerchShippingRecipientName(address) {
  if (!address) return null;
  const name = [address.nome, address.cognome].filter(Boolean).join(' ').trim();
  return name || null;
}
